import { render, staticRenderFns } from "./RequisitoTramite.vue?vue&type=template&id=d4a67976&"
import script from "./RequisitoTramite.vue?vue&type=script&lang=js&"
export * from "./RequisitoTramite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports